import {isFeatureEnabled} from '@github-ui/feature-flags'
import {hpcAttrs} from '@github-ui/hpc'
import {Sidebar} from '@github-ui/layout-primitives/Sidebar'
import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {PlusCircleIcon} from '@primer/octicons-react'
import {PageLayout} from '@primer/react'
import MarketplaceHeader from '@github-ui/marketplace-common/MarketplaceHeader'
import MarketplaceNavigation from '@github-ui/marketplace-common/MarketplaceNavigation'
import type {IndexPayload} from '@github-ui/marketplace-common'
import {SearchAndFilterProviderStack} from '@github-ui/marketplace-common/SearchAndFilterProviderStack'
import {IndexAndSearchContent} from '../components/IndexAndSearchContent'

function MarketplaceSidebarFooter() {
  return (
    <Sidebar.Footer>
      <Sidebar.Section divider>
        <Sidebar.Item href="/marketplace/new" leadingVisual={<PlusCircleIcon aria-hidden />}>
          Create extension
        </Sidebar.Item>
        <Sidebar.CollapseButton />
      </Sidebar.Section>
    </Sidebar.Footer>
  )
}

export function Index() {
  const payload = useRoutePayload<IndexPayload>()
  const useCollapsibleSidebarLayout = isFeatureEnabled('marketplace_sidebar_layout')

  if (useCollapsibleSidebarLayout) {
    return (
      <SearchAndFilterProviderStack>
        <SidebarPageLayout storageKey="marketplace-sidebar-collapsed">
          <SidebarPageLayout.Header width="full" padding="none">
            <MarketplaceHeader
              as="div"
              leadingAction={
                <SidebarPageLayout.SidebarTrigger aria-label="Open Marketplace categories" variant="default" />
              }
            />
          </SidebarPageLayout.Header>
          <SidebarPageLayout.Sidebar
            aria-label="Marketplace categories"
            dialogTitle="Marketplace categories"
            expandedWidth="medium"
            scrollable
            footerVariant="structural"
            footer={<MarketplaceSidebarFooter />}
          >
            <MarketplaceNavigation categories={payload.categories} collapsible />
          </SidebarPageLayout.Sidebar>
          <SidebarPageLayout.Content as="div">
            <div {...hpcAttrs()}>
              <IndexAndSearchContent payload={payload} />
            </div>
          </SidebarPageLayout.Content>
        </SidebarPageLayout>
      </SearchAndFilterProviderStack>
    )
  }

  return (
    <SearchAndFilterProviderStack>
      <MarketplaceHeader />
      <div {...hpcAttrs()}>
        <PageLayout>
          <PageLayout.Pane position="start">
            <MarketplaceNavigation categories={payload.categories} />
          </PageLayout.Pane>
          <PageLayout.Content as="div">
            <IndexAndSearchContent payload={payload} />
          </PageLayout.Content>
        </PageLayout>
      </div>
    </SearchAndFilterProviderStack>
  )
}
